import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import AboutHero, { BrandStory, Features, Testimonials, ContactCTA, FAQ } from './components/AboutContent';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '虫虫漫画网的内容是否完全免费？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，虫虫漫画网所有漫画资源均免费开放阅读。我们不设置任何付费墙，也不限制阅读次数。读者可以随时随地免费享受下拉式完整版韩国漫画。',
      },
    },
    {
      '@type': 'Question',
      name: '什么是下拉式阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '下拉式阅读（Webtoon/条漫）是源自韩国的原生漫画阅读方式。漫画以长条形式连续排版，读者只需向下滑动即可流畅阅读，无需翻页。这种方式更符合手机阅读习惯，沉浸感更强。',
      },
    },
    {
      '@type': 'Question',
      name: '虫虫漫画网的内容是否完整无删减？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，我们承诺所有漫画均为完整版无删减。我们与多家韩国漫画版权方合作，确保中文读者能够原汁原味地阅读每一部作品，不错过任何精彩内容。',
      },
    },
    {
      '@type': 'Question',
      name: '网站支持哪些设备访问？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '虫虫漫画网完美适配手机、平板和电脑端。其中手机端体验最佳，下拉式阅读在触摸屏上表现尤为出色。PC端同样支持鼠标滚轮流畅阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系商务合作或版权合作？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '欢迎发送邮件至 contact@chongchongmanhua.com，请在邮件中注明合作类型（商务合作/版权合作/媒体合作）及相关信息，我们的团队会在3个工作日内回复。',
      },
    },
  ],
};

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于虫虫漫画网',
  description:
    '虫虫漫画网成立于2020年，专注于下拉式韩国漫画完整版免费阅读平台，拥有2000+漫画资源，服务500万+忠实读者。',
  url: 'https://www.chongchongmanhua.com/about',
  mainEntity: {
    '@type': 'Organization',
    name: '虫虫漫画网',
    url: 'https://www.chongchongmanhua.com',
    description:
      '虫虫漫画网主打下拉式完整版免费阅读，无删减韩国漫画资源充足，下拉观看流畅不卡顿。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@chongchongmanhua.com',
      contactType: 'customer service',
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '上海',
      addressCountry: 'CN',
    },
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.chongchongmanhua.com' },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://www.chongchongmanhua.com/about',
      },
    ],
  },
};

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于虫虫漫画网 - 下拉式完整版漫画免费阅读平台"
        description="虫虫漫画网成立于2020年，专注于下拉式韩国漫画完整版免费阅读。2000+漫画资源，500万+忠实读者，无删减流畅观看。了解品牌故事、平台优势与联系方式。"
        keywords="关于虫虫漫画网,下拉式漫画,无删减漫画,免费阅读,韩国漫画,虫虫漫画网"
        canonicalUrl="https://www.chongchongmanhua.com/about"
        schema={[aboutSchema, faqSchema]}
      />

      <Navbar />

      <main>
        <AboutHero />
        <BrandStory />
        <Features />
        <Testimonials />
        <FAQ />
        <ContactCTA />
      </main>

      <Footer />
    </>
  );
}